<template>
    <div class="office-select-page">
        <!--     数据容器   -->
        <div class="office-select-wrap">
            <!--  搜索  -->
            <div class="search-content">
                <div class="input-out">
                    <input type="text" @input="filterJobList($event.target.value)" placeholder="搜索">
                    <img src="../../../assets/images/user-share/search.png" alt="">
                </div>

            </div>

            <!-- 数据列表 -->
            <div class="result-list-content">
                <!--             全部       -->
                <div @click.stop="selectAllOffice" class="result-item" :class="{'result-item-active':selectJobAll}">
                    <span>全部</span>
                    <img v-if="selectJobAll" src="../../../assets/images/user-share/select_y.png" alt="">
                    <img v-else src="../../../assets/images/user-share/select_n.png" alt="">
                </div>
                <!--              办事处列表      -->
                <div @click.stop="selectOffice(item)" class="result-item" :class="{'result-item-active':item.select}"
                     v-for="item in rankSelectJobResult"
                     :key="item.id">
                    <span>{{ item.name }}</span>
                    <img v-if="item.select" src="../../../assets/images/user-share/select_y.png" alt="">
                    <img v-else src="../../../assets/images/user-share/select_n.png" alt="">
                </div>

            </div>
        </div>
        <!--   确认容器  -->
        <div class="confirm-button" @click="confirmButtonClick">确认</div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "office-select",
    computed: {
        ...mapGetters({
            // 是否选中办事处
            selectJobAll: 'userShareData/selectJobAll',
            // 数据筛选办事处数据
            rankSelectJobResult: 'userShareData/rankSelectJobResultList',
        }),
    },
    methods: {
        /**
         * 选中所有办事处
         */
        selectAllOffice() {
            this.$store.commit({type: "userShareData/CHANGE_SELECT_OFFICE", all: this.selectJobAll});
        },
        /**
         * 选中单个办事处
         * @param item
         */
        selectOffice(item) {
            this.$store.commit({type: "userShareData/CHANGE_SELECT_OFFICE", office: item});
        },
        /**
         * 改变输入搜索词
         * @param input
         */
        filterJobList(input) {
            this.$store.commit({type: "userShareData/CHANGE_SEARCH_WORD", input});
        },
        /**
         * 确认按钮点击
         */
        confirmButtonClick() {
            this.filterJobList();
            this.$router.back();
        }
    }
}
</script>

<style scoped lang="scss">
$greenColor: #338445;

.office-select-page {
    * {
        box-sizing: border-box;
    }

    height: 100%;
    background: #FFFFFF;
    padding: 32px 24px;
    display: flex;
    flex-direction: column;

    .office-select-wrap {
        flex: 1;
        box-shadow: 0 0 20px 0 rgba(197, 214, 202, 0.7);
        border-radius: 10px;
        overflow: auto;


        .search-content {
            position: sticky;
            top: 0;
            padding: 24px 38px;
            background: $greenColor;
            font-size: 28px;

            .input-out {
                width: 100%;
                height: 66px;
                border: 02px solid #FFFFFF;
                border-radius: 66px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 20px;

                img {
                    flex: 0;
                    width: 42px;
                    height: 42px;
                }

                input {
                    flex: 1;
                    background: transparent;
                    padding: 0 20px;
                    color: #FFFFFF;

                    &::placeholder {
                        color: white;
                    }
                }
            }
        }

        .result-list-content {
            padding: 10px 0;

            .result-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 01px solid #D2D2D2;
                padding: 26px 36px;
                font-size: 32px;
                transition: all 0.5s;

                img {
                    width: 24px;
                    height: 24px;
                }
            }

            .result-item-active {
                color: $greenColor;
            }
        }
    }

    .confirm-button {
        flex: 0 0 88px;
        background-color: $greenColor;
        font-size: 32px;
        border-radius: 10px;
        margin-top: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFFFFF;
        letter-spacing: 20px;
    }
}
</style>
